// Get shortcode from current hostname
export const getShortcodeFromHostname = () => {
  const hostname = window.location.hostname;
  const parts = hostname.split('.');
  
  // Check if it's a subdomain format like "shortcode.TKT1.ai"
  if (parts.length >= 3 && parts[1] === 'TKT1' && parts[2] === 'ai') {
    return parts[0].toLowerCase();
  }
  
  // Default fallback
  return 'tkt1';
};

// Get token key based on company shortcode
export const getTokenKey = (shortcode = null) => {
  if (!shortcode) {
    // Try to get shortcode from hostname
    const hostname = window.location.hostname;
    const shortcodeMatch = hostname.match(/^([^.]+)\./);
    if (shortcodeMatch) {
      shortcode = shortcodeMatch[1];
    } else {
      // Fallback to default
      shortcode = 'tkt1';
    }
  }
  return `${shortcode}_token`;
};

// Get token from localStorage
export const getToken = (shortcode = null) => {
  const tokenKey = getTokenKey(shortcode);
  return window.localStorage.getItem(tokenKey);
};

// Set token to localStorage
export const setToken = (token, shortcode = null) => {
  const tokenKey = getTokenKey(shortcode);
  window.localStorage.setItem(tokenKey, token);
};

// Remove token from localStorage
export const removeToken = (shortcode = null) => {
  const tokenKey = getTokenKey(shortcode);
  window.localStorage.removeItem(tokenKey);
};
